'use client';

import Link from 'next/link';
import { Facebook, Twitter, Instagram, Github } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function Footer() {
  const t = useTranslations('footer');

  return (
    <footer className="bg-gradient-to-b from-primary to-very-dark-navy border-t border-very-light-turquoise/25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('links')}</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link href="/safetizen" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('safetizen')}
                </Link>
              </li>
              <li>
                <Link href="/earit" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('earit')}
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('contact')}
                </Link>
              </li>
              <li>
                <Link href="/a-propos" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('about')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/mentions-legales" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('mentionsLegales')}
                </Link>
              </li>
              <li>
                <Link href="/politique-confidentialite" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('politiqueConfidentialite')}
                </Link>
              </li>
              <li>
                <Link href="/cgu" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                  {t('cgu')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{t('social')}</h3>
            <div className="flex gap-4">
              <a href="#" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-white/90 hover:text-very-light-turquoise transition-colors">
                <Github size={20} />
              </a>
            </div>
          </div>

          <div>
            <p className="text-white/90 text-sm">{t('copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
